<script setup>
defineProps({
  show: Boolean
})
</script>

<template>
  <div class="loading-element" :class="{ hide: !show }">
    <span class="loading" />
  </div>
</template>